export default __webpack_public_path__ + "static/media/SouthAmerica_01.2c27a0ec.png";